import { createSelector } from 'reselect';

const getState = (state) => state.directOrderRecurring.data.dropOff;

const getAddDays = createSelector(getState, ({ addDays }) => addDays);
export default {
  getAddDays,
};
